export const transactionsSubMenu = [{
  path: '/transaction/list/',
  component: () => import('@/views/transaction/list.vue'),
  name: 'Transaction',
  meta: {
    // title: 'accountManagement.transaction.title',
    title: 'accountManagement.transaction.title',
    roles: ['Super Admin', 'Admin', 'Account Manager', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Sales Manager', 'Unit Manager', 'Payment Manager'],
    noCache: true,
    icon: 'inr'
  }
}, {
  path: '/transaction/list/:id(.*)',
  component: () => import('@/views/transaction/list.vue'),
  name: 'Transaction',
  meta: {
    title: 'accountManagement.transaction.title',
    roles: ['Super Admin', 'Admin'],
    noCache: true,
    hidden: true
  }
}, {
  path: '/transaction/add/:id(.*)',
  component: () => import('@/views/transaction/manage.vue'),
  name: 'accountManagement.transaction.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'accountManagement.transaction.add',
    noCache: true,
    activeMenu: '/transaction/list/:id(.*)',
    hidden: true
  }
}, {
  path: '/transaction/edit/:id(.*)',
  component: () => import('@/views/transaction/manage.vue'),
  name: 'accountManagement.transaction.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'accountManagement.transaction.edit',
    noCache: true,
    activeMenu: '/transaction/list/:id(.*)',
    hidden: true
  }
}, {
  path: '/transaction/rtgs/:id(.*)',
  component: () => import('@/views/transaction/rtgs.vue'),
  name: 'accountManagement.transaction.rtgs',
  props: {
    isEdit: true
  },
  meta: {
    title: 'accountManagement.transaction.rtgs',
    noCache: true,
    activeMenu: '/transaction/list/:id(.*)',
    hidden: true
  }
}];